export const UserRole = {
  EMPLOYEE: 'EMPLOYEE',
  IT: 'IT',
  DIRECTION: 'DIRECTION',
  ADMIN: 'ADMIN',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

/** Rôles qui traitent les tickets (ex-agents + admins). */
export const STAFF_ROLES: UserRole[] = [UserRole.IT, UserRole.ADMIN];

/** Rôles ayant accès aux rubriques Modules et Planning. */
export const PLANNING_ROLES: UserRole[] = [UserRole.ADMIN, UserRole.IT, UserRole.DIRECTION];

export function isStaff(role: UserRole): boolean {
  return STAFF_ROLES.includes(role);
}

export function canViewPlanning(role: UserRole): boolean {
  return PLANNING_ROLES.includes(role);
}
